// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"id":"grid-view"},"nodeName":"g","children":[{"attributes":{"id":"fill1"},"nodeName":"g","children":[{"attributes":{"fill":"transparent","d":"M10 3H3V10H10V3Z"},"nodeName":"path","children":[]},{"attributes":{"fill":"transparent","d":"M14 3H21V10H14V3Z"},"nodeName":"path","children":[]},{"attributes":{"fill":"transparent","d":"M21 14H14V21H21V14Z"},"nodeName":"path","children":[]},{"attributes":{"fill":"transparent","d":"M10 14H3V21H10V14Z"},"nodeName":"path","children":[]}]},{"attributes":{"id":"stroke1"},"nodeName":"g","children":[{"attributes":{"stroke":"currentColor","d":"M10 3H3V10H10V3Z","stroke-linecap":"square","stroke-width":2},"nodeName":"path","children":[]},{"attributes":{"stroke":"currentColor","d":"M14 3H21V10H14V3Z","stroke-linecap":"square","stroke-width":2},"nodeName":"path","children":[]},{"attributes":{"stroke":"currentColor","d":"M21 14H14V21H21V14Z","stroke-linecap":"square","stroke-width":2},"nodeName":"path","children":[]},{"attributes":{"stroke":"currentColor","d":"M10 14H3V21H10V14Z","stroke-linecap":"square","stroke-width":2},"nodeName":"path","children":[]}]}]}]};

@tag('t-icon-grid-view')
export default class GridViewIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'grid-view',
    }
  }
}
